import { MIN_VARIANT_QUANTITY } from './constants';

export const isMinVariantQuantity = (variantsQuantity: number) => {
    return variantsQuantity <= MIN_VARIANT_QUANTITY;
};
